import React, { useState, useEffect, Fragment } from 'react';
import { useHistory, useParams} from "react-router-dom";
import axios from 'axios';
import { Tabs, Tab, Content } from "./Tab";
import UserMenu from './UserMenu';
import Sidebar from './Sidebar';
import Box from './Box';
import Alert from './Alert';
import Popover from './ui/Popover';
import ModalWindow from './ModalWindow';
import ClientHeader from './custom/clientHeader/ClientHeader';
import ClientDocsList from './custom/clientDocsList/ClientDocsList';
import ClientTaskTree from './custom/clientTaskTree/ClientTaskTree';
import IconView from './icons/IconView';
import Tools from './Tools';
import './css/Home.css';
import './css/MainForm.css'; 
import './css/Softphone.css'; 
import { ReactComponent as IconCurrentTask } from './icons/currentTask.svg';
import { AssistedIcon, OutboundIcon, InboundIcon, GetAudioIcon } from './icons/svgIcons';
import { useSoftphone } from './SoftphoneContext.jsx';
import GetAudioCall from './GetAudioCall';


const MainForm = (props) => {
    let history = useHistory();

    const [error, setError] = useState(false);
    const [sessionData, setSessionData] = useState({}); 
    const [activeTab, setActiveTab] = useState(0);
    //const [currentCompanyId, setCurrentCompanyId] = useState(null);
    const [client, setClient] = useState(null); 
    const [campaign, setCampaign] = useState(null); 
    const [tasks, setTasks] = useState([]); 
    const [taskPagination, setTaskPagination] = useState(null); 
    const [companyTaskFields, setCompanyTaskFields] = useState(null);
    const [documentsLength, setDocumentsLength] = useState(0); 
    const [otherPhoneNumbers, setOtherPhoneNumbers] = useState([]); 
    const [debt, setDebt] = useState(0); 
    const [offer, setOffer] = useState(''); 
    const [userStatus, setUserStatus] = useState(null); 
    const [currentRow, setCurrentRow] = useState(-1); 
    const [currentRowForAudio, setCurrentRowForAudio] = useState(-1);
    const { clientId } = useParams(); 
    const { campaignId } = useParams(); 
    const { phone } = useParams(); 
    const { clientStatus } = useParams(); 

    const [callStatus, setCallStatus] = useState('normal'); 
    const [muteStatus, setMuteStatus] = useState(false); 
    const [showOtherPhoneNumbers, setShowOtherPhoneNumbers] = useState(false); 
    const [loadingClient, setLoadingClient] = useState(false);
    const [loadingCampaign, setLoadingCampaign] = useState(false);
    const [loadingTasks, setLoadingTasks] = useState(false);
    const [savedTask, setSavedTask] = useState(false);
    //const [keySufix, setKeySufix] = useState("hh");

    //const [waitingCallsWindow, setWaitingCallsWindow] = useState(false);
    const [popupICVisible, setPopupICVisible] = useState(false);
    const [popupTSKVisible, setPopupTSKVisible] = useState(-1);
    const [base64ImagePreview, setBase64ImagePreview] = useState(null); 
    const [disconnectionExecuted, setDisconnectionExecuted] = useState(false); 

    const { outgoingCallStatus, incomingCallStatus, hangUpAllCalls } = useSoftphone();

    useEffect(() => {

        //save current client in session
        sessionStorage.setItem('currentClient', JSON.stringify({campaignId:campaignId, clientId:clientId}));

        //receive instance and set in variable "softphone"
        //setSoftphone(props.sfref.current.contentWindow);

        //IMPORTANT:
        //HERE WE CREATE PUBLIC FUNCTIONS TO INVOQUE
        //PRIVATE FUNCTION THAT CHANGE CALLSTATUS.
        //CALLSTATUS IS USED TO DETERMINE BUTTONS TO SHOW/HIDE
        var fnImpl = `publicFnSetCallStatus(arguments[0]);`;
        window['publicFnSetCallStatus'] = setCallStatus;
        window['notifyCallStatus'] = new Function(fnImpl);


        if (!sessionStorage.getItem('sessionData')) {
            history.push('/login'); 
        }else{

            //get session data from sessionStorage
            let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
            setSessionData(currentSessionData);
            props.setCurrentClient(clientId);


            (async () => {
                
            //get campaign data
            let currentCampaign;
            setLoadingCampaign(true);
            await axios.get(`${process.env.REACT_APP_URI_API_CRM}/campaign`, {
                params: { campaignId: campaignId }
            })
            .then(function (response) {
                currentCampaign=response.data;
                //console.log('🐞DEBUG currentCampaign:',currentCampaign);
                props.setSelectedCampaign(currentCampaign); //notify to PARENT (to pass to softphone)
                setCampaign(currentCampaign);
                setLoadingCampaign(false);

                /*
                *Al cargar campaña, si esta es PROGRESIVA setea
                la pausa default "cargando ficha" 
                */
                if (currentCampaign.type === "PROGRESSIVE") {
                    // console.log('🐞DEBUG acá deería setear estado "preview cliente"');
                    // setUserStatus({ paused: true, code: 'CLPREV', desc: 'Preview cliente' });
                }
            })
            .catch ((error) => {
                if (error?.response?.data?.error === 'Unauthorized') {
                    if (!disconnectionExecuted) {
                        Tools.forceLogout(history);
                        setDisconnectionExecuted(true);
                    }
                }
                setError(error.message);
                setLoadingCampaign(false);
            });


             //client
             setLoadingClient(true);            
             let url = new URL(`${process.env.REACT_APP_URI_API_CRM}/client`);
             url.search = new URLSearchParams({
                 idClient: clientId,
                 idCompany: currentCampaign.companyId,
                 assignmentId:currentCampaign.assignmentId
             });

            if (clientStatus){
                url.searchParams.append('status', clientStatus);
            }

             fetch(url, {
                 method: 'GET',
                 contentType: 'application/json',
                 headers: { 'Authorization': currentSessionData.token }
             })
             .then(res => res.json())
             .then(
                 (result) => {

                     if (result.error==='Client not found'){
                            setLoadingClient(false); 
                            setError('Cliente no encontrado');
                            return;
                     }


                     setLoadingClient(false); 
                     //setClient(result);
                     updateClientData(result);


                     //console.log('🐞DEBUG CLIENT:', result);

                     //validacion para DEVOLVERSE a pantalla de esperando llamados
                     //console.log('🐞DEBUG CLIENT:', result);
                     if (
                            (currentCampaign?.type === "PROGRESSIVE" && Tools.clientIsBlocked(result)) 
                         || (currentCampaign?.type === "PROGRESSIVE" && result?.lastTaskDateInSameWeek) 
                         || (currentCampaign?.type === "PROGRESSIVE" && incomingCallStatus === 'none') 
                         || (currentCampaign?.type === "PROGRESSIVE" && client.status === 0) //CLIENTE NO VIGENTE
                     ) { 
                        
                        //if calling is active, then terminate it
                        if (incomingCallStatus === 'incoming' || incomingCallStatus === 'confirmed'){
                            //softphone.terminateCall();
                            hangUpAllCalls();
                        }

                        setTimeout(() => {
                             //setear a dispobible TAMBIEN
                             //SOLO si estamos een PROGRESIVO
                             setUserStatus({ paused: false, code: 'ACTIVE', desc: 'Disponible' });
                             //revisar si se debe esperar a que cambie el estado    
                             history.push('/waitingCalls/' + campaignId)
                         }, 4000);
                     } 

                 },
                 (error) => {
                     setLoadingClient(false); 
                     setError(error);
                 }
             );

             getTasks(currentCampaign.companyId);

             //SIEMPRE QUE CAMBIA CLIENTE ES NECESARIO
             //CAMBIAR EL ESTADO WaitingCallsWindow(true)
             //PARA QUE CIERRE EL POPUP DE ESPERA DE LLAMADOS
             //setWaitingCallsWindow(false);

            })();

        }

    }, [clientId]);

    
    useEffect(() => {
        //si finaliza la llamada y AUN no se ha guardado gestión 
        //solo entonces pasará a ingresando gestión
        // if ((outgoingCallStatus === 'ended' || incomingCallStatus==='ended') && !savedTask){
        //     setUserStatus({ paused: true, code: 'INGRESANDO GESTIÓN', desc:'Ingresando gestión'});
        // } 

        //if ((outgoingCallStatus === 'ended' || incomingCallStatus === 'ended') && !savedTask) {
        if ((outgoingCallStatus === 'ended' || incomingCallStatus === 'ended' || incomingCallStatus === 'failed') && !savedTask) {
            if (Tools.clientIsBlocked(client)) {
                if (campaign.type === "ASSISTED") {
                    setUserStatus({ paused: false, code: 'LOGGED', desc: 'En sistema' });
                } else { //progresiva
                    setUserStatus({ paused: false, code: 'ACTIVE', desc: 'Disponible' });
                }
            } else {
                //pasa a INGRESANDO GESTION cuando se permite ingresarla
                setUserStatus({ paused: true, code: 'INGRESANDO GESTIÓN', desc: 'Ingresando gestión' });
            }
        } 

        if (incomingCallStatus === 'confirmed' || outgoingCallStatus === 'confirmed'){
            setUserStatus({ paused: false, code: 'CALLING', desc: 'En llamada' });
        }

        console.log('incomingCallStatus 👉 ', incomingCallStatus);
        console.log('outgoingCallStatus 👉 ', outgoingCallStatus);

    }, [outgoingCallStatus, incomingCallStatus]); ///<---IMPORTANTE, DEBE RECIBIR ESTADO PARA REGISTRAR ESTADO DEL EJECUTIVO


    const callbackAfterSaveTask=()=>{ 
        setSavedTask(true);
        if(campaign.type==="PROGRESSIVE"){

            //setWaitingCallsWindow(true);
            history.push('/waitingCalls/'+campaignId); 
        } else {
            //SOLO SI ESTAMOS PARADOS EN CAMPAÑA ASISTIDA
            //REFRESCAMOS DE INMEDIATO LA LISTA DE GESTIONES
            getTasks(campaign.companyId);
        }
    }

    const getTasks = (companyId, pagination=null) => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData')); 
        
        let serviceParams =  {
            clientId: clientId,
            companyId: companyId
        }

        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/clientTasksHistory`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: serviceParams
        };
        axios(options).then(response => {
            if(response.data[0]){
                setTasks(response.data[0].tasks);
            } else {
                //DEBE REEMPLAZAR EL ARREGLO DE GESTIONES 
                //(POR SI FICHA ANTERIOR TIENE GESTIONES Y ESTA ESTÁ VACIO)
                setTasks([]); 
            }
        });
    }



    const getOtherPhoneNumbers = () => {
        setShowOtherPhoneNumbers(!showOtherPhoneNumbers);

        if (!showOtherPhoneNumbers){
            let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));

            //campaignDetails
            let url = new URL(`${process.env.REACT_APP_URI_API_CRM}/phoneNumbers`);
            url.search = new URLSearchParams({
                idClient: clientId,
            });

            fetch(url, {
                method: 'GET',
                contentType: 'application/json',
                headers: { 'Authorization': currentSessionData.token }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    setOtherPhoneNumbers(result.phoneNumbers);
                },
                (error) => {
                    console.log('Se produjo un errrooooor:', error);
                    setError(error);
                }
            )
        }
    }
    
    
    const handleClick = e => {
        const index = parseInt(e.target.id, 0);
        if (index !== activeTab) {
            setActiveTab(index);
        }
    };


    const selectRow = (index) => {
        if (index!==currentRow){
            setCurrentRow(index);
        } else {
            setCurrentRow(-1);
        }
    }

    const selectRowToListenAudio = (index) => {
        if (index !== currentRowForAudio) {
            setCurrentRowForAudio(index);
        } else {
            setCurrentRowForAudio(-1);
        }
    }

    const updateClientData=(client)=>{
        setClient(client);
        props.setCurrentPhone(client.currentPhone);
    }

    return (
        <div className="mainWrapper">
            {base64ImagePreview ? (
                <ModalWindow closeMethod={() => setBase64ImagePreview(null)}>
                    <img className='bigPreview' src={base64ImagePreview} />
                </ModalWindow>
            ) : null}
            
            <Sidebar key={props.inboundConnectedQueues} current="1" currentCampaignId={campaignId} softphoneConnectionStatus={props.softphoneConnectionStatus}/>
            <div className="main">
                <div className="headerWrapper">
                    <div className="titleWrapper">
                        {client ? (
                            <h1>
                            <IconCurrentTask />
                            {client.clienteNombre??'No registra' + ' ' + (client.clienteApPat??'')  + ' ' + (client.clienteApMat??'')}
                            {client.status===0?(<span className='noDebtSpan'>CLIENTE NO VIGENTE</span>):null}
                            </h1>):null}
                        {campaign ? (<>
                            <span className="upper">
                                <span className='companyColor' style={{borderColor:campaign.company_info.color}}>{campaign.company_info.name}</span>
                                <span> [
                                    {campaign.type === 'ASSISTED' ? <span><AssistedIcon className="vbottom" width="22" height="22"/> asistida</span>
                                    : campaign.type === 'PROGRESSIVE' ? <span><OutboundIcon className="vbottom" width="22" height="22" /> progresiva</span>
                                    : campaign.type === 'GENERIC_INBOUND' ? <span> <InboundIcon className="vbottom" width="22" height="22" /> inbound</span>
                                    : null}
                                    ] </span>
                                 / {campaign.name}</span>
                            <div className="rel ib">
                                <a onClick={() => setPopupICVisible(!popupICVisible)}><i className='info inline'/></a>
                                <Popover show={popupICVisible} position="right">
                                    <dl>
                                        <dt>Id Registro</dt>
                                        <dd>{client ? client._id : null}</dd>
                                        <dt>Id Campaña</dt>
                                        <dd>{campaign._id}</dd>
                                        <dt>Id Asignación</dt>
                                        <dd>{campaign.assignmentId}</dd>
                                        <dt>Id Cedente</dt>
                                        <dd>{campaign.companyId}</dd>
                                    </dl>
                                </Popover>
                            </div>
                        </>):null}
                    </div>
                    <div className="flexWrapper">    
                        <UserMenu externalUserStatus={userStatus} setInboundConnectedQueues={props.setInboundConnectedQueues}/>
                    </div>
                </div>

                {Tools.clientIsBlocked(client) ?
                    client?.lastTaskDateInSameWeek?(
                        <div className="clientAlert">Cliente bloqueado, motivo: <b>Contacto Directo</b></div>
                    ):(
                        <div className="clientAlert">Cliente bloqueado, motivo: <b>{client?.blockedDesc}</b></div>
                    )
                : campaign?.type === "PROGRESSIVE" && incomingCallStatus === 'none' ? (
                    <div className="clientAlert">*Bloqueo por llamada no disponible. <i className="spinner"></i></div>
                ) : null}



                {client && campaign ? ( 
                    <Fragment>    

                        <ClientHeader key={client.clientId + client.random} campaign={campaign} client={client} phone={phone} updateClientMethod={updateClientData}/>

                        <Tabs className='tabset'>
                            {campaign.company_info.debtCollector ? (
                                <Tab onClick={handleClick} className={activeTab !== 0?'inactive':undefined} active={activeTab === 0} id={0}>Documentos <i></i> {<span>({documentsLength})</span>}</Tab>
                            ):null}
                            <Tab onClick={handleClick} className={activeTab !== 1 ? 'inactive' : undefined} active={activeTab === 1 || !campaign.company_info.debtCollector} id={1}>Gestiones cliente <i className={loadingTasks ? 'loading' : null}></i> {!loadingTasks && (<span>({tasks.length})</span>)}</Tab>
                        </Tabs>
                        
                        {campaign.company_info.debtCollector ? (
                            <Content active={activeTab === 0} className="tabContent niceScrollBar">
                                    {campaign ? (
                                    <ClientDocsList key={client.clientId} client={client} currentSessionData={sessionData} companyId={campaign.companyId} clientId={clientId} campaignId={campaign._id} debt={debt} setDebtFn={setDebt}  setOfferFn={setOffer} setDocumentsLength={setDocumentsLength}/> 
                                    ) : null}
                            </Content>
                        ) : null}
                        <Content active={activeTab === 1 || !campaign.company_info.debtCollector} className="tabContent niceScrollBar">
                            
                            {(tasks.length > 0) ? (
                                <Fragment>
                                    <table className="fullWidth">
                                        <thead>
                                            <tr>
                                                <th>Fecha</th>
                                                <th>Campaña</th>
                                                <th>Teléfono</th>
                                                {campaign.company_info._id===107?(
                                                    <Fragment>
                                                        <th>Tipo Gestión</th>
                                                        <th>Causal de mora</th>
                                                    </Fragment>
                                                ):(
                                                    <Fragment>
                                                        <th>Tipo contacto</th>
                                                        <th>Tipo gestión</th>
                                                    </Fragment>
                                                )}

                                                {/* {campaign.company_info._id === 116 || campaign.company_info._id === 117  ? (
                                                    <th>Estado Cobranza</th>
                                                ):null} */}

                                                <th>Ejecutivo</th>
                                                <th colSpan="2"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tasks.map((listValue, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td className='rel'>
                                                            <a onClick={() => { if (popupTSKVisible === index) { setPopupTSKVisible(-1)} else {setPopupTSKVisible(index)}}}><i className='info inline' /></a>
                                                            <Popover show={popupTSKVisible===index} position="right">
                                                                <dl>
                                                                    <dt>Id Gestión</dt>
                                                                    <dd>{listValue._id}</dd>
                                                                    <dt>Id Campaña</dt>
                                                                    <dd>{listValue.campaignId}</dd>
                                                                </dl>
                                                            </Popover>    
                                                            {Tools.fdtCL(listValue.date)}</td>
                                                        <td>{listValue.CMP_DETAILS?.name}</td>
                                                        <td>{listValue.phone}</td>
                                                        {/* <td>{listValue.CT_DETAILS?.desc}</td> */}

                                                        {/* {listValue.CT_DETAILS ? (<td>{listValue.CT_DETAILS?.desc}</td>) : (<td>{listValue.callStatus}</td>)} */}



                                                        {listValue.type === 'E' ? (<td>{listValue.CT_DETAILS?.desc}</td>)
                                                        : listValue.type === 'M' ? (<td>Gestión Máquina</td>)
                                                        : null}




                                                        
                                                        {listValue.type === 'E' ? (<td>{listValue.TT_DETAILS?.desc}</td>)
                                                            : listValue.type === 'M' ? (<td>{listValue.ACCH_DETAILS?.homologation}</td>)
                                                        : null}

                                                        


                                                        {/* {campaign.company_info._id === 116 || campaign.company_info._id === 117 ? (
                                                            <td>{listValue.collectStatusDesc ?? (<span className="filler" />)}</td>
                                                        ) : null} */}
                                                        <td>{listValue.USR_DETAILS.name}</td>

                                                        <td className="rel">
                                                            <a style={{"anchorName": `--pop-task${index}`}} tooltip="Ver más info de la gestión" onClick={() => selectRow(index)}><IconView size="25" color="#949494" /></a>
                                                            <Popover className="anchored" anchorName={`--pop-task${index}`} show={index === currentRow} width="420px">
                                                                <dl>

                                                                    {campaign.company_info._id === 116 || campaign.company_info._id === 117 ? (
                                                                        <>
                                                                            {listValue.channel ? (<><dt>CANAL GESTIÓN</dt><dd>{listValue.CHN_DETAILS?.desc}</dd></>):null}
                                                                            {listValue.response ? (<><dt>RESPUESTA</dt><dd>{listValue.RESP_DETAILS?.desc}</dd></>):null}
                                                                            {listValue.debtReason ? (<><dt>MOTIVO NO PAGO</dt><dd>{listValue.DR_DETAILS.desc}</dd></>):null}
                                                                            {listValue.authType ? (<><dt>AUTORIZACIÓN</dt><dd>{listValue.AUT_DETAILS?.desc}</dd></>):null}
                                                                        </>
                                                                    ):null}


                                                                    {listValue.taskFields.map((field, index) => {
                                                                        return (
                                                                            <Fragment key={field.name || index}>
                                                                                <dt>{field.name}</dt>
                                                                                <dd>
                                                                                    {field.type === 'AMM' ? Tools.fmtClAmmount(field.value) :
                                                                                     field.type === 'DATE' ? Tools.fdCL(field.value) :
                                                                                     field.type === 'IMG' ? (<img className='preview' src={field.value} onClick={() => setBase64ImagePreview(field.value)}/>) :
                                                                                     field.value }
                                                                                </dd>
                                                                            </Fragment>
                                                                        )
                                                                    })}
                                                                    {listValue.observation?(
                                                                        <>
                                                                            <dt>Observación</dt>
                                                                            <dd><span>{listValue.observation}</span></dd>
                                                                        </>
                                                                    ) : null}

                                                                    {listValue.audioRecordUri?(
                                                                        <>
                                                                            <dt>Grabación</dt>
                                                                            <dd><audio preload="auto" controls src={'https://kintaro.athenacampaign.com/' + listValue.audioRecordUri} type="audio/mpeg" /></dd>

                                                                        </>
                                                                    ):null}


                                                                </dl>
                                                            </Popover>
                                                        </td>

                                                        <td className="rel">
                                                            <a style={{ "anchorName": `--pop-audio${index}` }} tooltip="Reproducir grabación" onClick={() => selectRowToListenAudio(index)} disabled={listValue.USR_DETAILS.name === 'machine' ? true : false}>
                                                                <GetAudioIcon size="23" color={listValue.USR_DETAILS.name !== 'machine' ? '#949494' : '#c9c9c9'} />
                                                            </a>
                                                            <Popover className="anchored" anchorName={`--pop-audio${index}`} show={index === currentRowForAudio}>
                                                                <GetAudioCall key={index} task={listValue} />
                                                            </Popover>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                    {taskPagination ? (
                                        <p className="pagination">
                                            Mostrando [{tasks.length} de {taskPagination.total} registros]
                                            {(tasks.length < taskPagination.total) ? (
                                                <span> &nbsp; <a className={loadingTasks ? 'link loading' : 'link'} onClick={() => getTasks(campaign.companyId, { page: taskPagination.page + 1, skip: tasks.length, limit: 5 })}>Ver más</a></span>
                                            ) : null}
                                        </p>
                                    ) : null}
                                </Fragment>
                            ) :
                                <p>Aún no se han realizado gestiones para el cliente en esta campaña.</p>
                            }


                        </Content>

                        {campaign.company_info.debtCollector?(
                            <div className="flex">
                                <div>
                                    <h4 className="sectionTitle">INFORMACIÓN DEUDA</h4>
                                    <div className="flexRow">
                                        <div className="flexCol">
                                            <Box type="readOnly" className="right" label="Deuda total" value={Tools.fmtClAmmount(debt)}></Box>
                                            
                                            {client.companyId === 128?(
                                                <Box type="readOnly" className="x4" label="Oferta" value={offer}></Box>
                                            ):null}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : null}

                        {/* <TaskTree key={clientId} campaign={campaign} client={client} callbackAfterSaveTask={callbackAfterSaveTask} setUserStatus={setUserStatus} iced={incomingCallStatus} lastRecordingData={props.lastRecordingData} setLastRecordingData={props.setLastRecordingData} /> */}
                        <ClientTaskTree key={clientId} campaign={campaign} client={client} callbackAfterSaveTask={callbackAfterSaveTask} setUserStatus={setUserStatus} iced={incomingCallStatus} lastRecordingData={props.lastRecordingData} setLastRecordingData={props.setLastRecordingData} debt={debt}/>

                    </Fragment>) : 

                    loadingClient ? (
                        <Alert><i className="loading"></i> Buscando cliente...</Alert>
                    ) : <Alert className="error">Cliente no encontrado</Alert>
                
                }
            </div>    
        </div>
    );
}

export default MainForm;